var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},_vm._l((_vm.users),function(user,index){return _c('span',{key:user.id,class:`${
      index ? '-ml-4' : ''
    } inline-block rounded-md text-white shadow-solid`},[_c('thumbnail',{attrs:{"size":"36px","username":user.name,"src":user.avatar,"has-border":""}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }